import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MainLayout from '../components/layouts/MainLayout';
import StaffList from '../components/views/staffs/StaffList';
import Spin from '../components/Spin';
import { staffListAction } from '../stores/actions';
import * as api from '../api';
import useDebounce from '../lib/useDebounce';

const StaffListContainer = ({history}) => {
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isDebounce, setIsDebounce ] = useState(false); //디바운싱 사용 구분을 위해 추가
  const { staffListTotal, staffListItems, currentPageNumber, paginationItem, filterItem } = useSelector(state => state.staffList);
  const dispatch = useDispatch();

  const setStaffList = useCallback((staffList) => {
    dispatch(staffListAction.setStaffList(staffList));
  }, [dispatch]);

  const setCurrentPageNumber = useCallback((currentPageNumber) => {
    dispatch(staffListAction.setCurrentPageNumber(currentPageNumber));
  }, [dispatch]);

  const setPaginationItem = useCallback((paginationItem) => {
    dispatch(staffListAction.setPaginationItem(paginationItem));
  }, [dispatch]);

  const setFilterItem = useCallback((filterItem, isDebounce) => {
    setIsDebounce(isDebounce); //디바운싱 처리를 위해 하위 Component에서 구분을 받아옴
    dispatch(staffListAction.setFilterItem(filterItem));
  }, [dispatch]);

  const changeHotel = useCallback(() => {
    dispatch(staffListAction.initStaffListState());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const listStaff = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await api.listStaff({...filterItem, ...paginationItem});
      setStaffList(res.data);
      // dispatch(sidebarAction.setSidebarItem({staffCount: res.data.total}));
    } catch (error) {
      setStaffList({
        total: 0,
        items: [],
      });
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [setStaffList, filterItem, paginationItem]);

  //디바운싱 훅으로 이동
  const handleDebounce = useCallback(
    useDebounce((listStaff) => listStaff(), 300) //0.3초 동안 미입력 시 함수 실행
  ,[]);

  useEffect(() => {
    try {
      !isDebounce? listStaff() : handleDebounce(listStaff); //디바운싱 처리
    } catch (error) {
      throw error;
    }
  }, [listStaff, isDebounce, handleDebounce]);

  return (
    <Fragment>
      <Spin isSpin={isLoading}/>
      <MainLayout
        history={history}
        refresh={() => changeHotel()}
        ContentBody={(
          <StaffList
            staffListTotal={staffListTotal}
            staffListItems={staffListItems}
            filterItem={filterItem}
            paginationItem={paginationItem}
            currentPageNumber={currentPageNumber}
            listStaffApi={listStaff}
            setFilterItem={setFilterItem}
            setPaginationItem={setPaginationItem}
            setCurrentPageNumber={setCurrentPageNumber}
            history={history}
          />
        )}
      />
    </Fragment>
  );
}

export default StaffListContainer;